@if (pending) {
  <ng-icon
    name="HeroRefresh"
    class="primary spin"
    aria-label="Loading"
    role="status"
  ></ng-icon>
} @else {
  <ng-content></ng-content>
}
